<!--新增编辑库存商品，基础配件转化为库存商品操作弹窗-->
<!--这个页面已经没有用于商品列表的新增编辑库存商品，只用于基础配件转化为库存商品操作弹窗，还有就是用于一些搜索配件弹窗中新增商品，mark by qdl 2021/2/24-->
<template>
    <div>
        <el-dialog :close-on-click-modal="false" :title="title" :visible="dialogFormVisible" width="1380px" :show-close="true" :before-close="handleClose" append-to-body>
            <div v-loading="loading">
                <div class="content-zone">
                    <div class="form-main-left">
                        <el-form :rules="rules" :model="partData" ref="partData" label-width="80px" class="form-ctn">
                            <div class="form-main">
                                <div class="form-line">
                                    <div class="form-item">
                                        <el-form-item label="汽配名称" prop="GoodName">
                                            <el-autocomplete
                                                ref="addapcode"
                                                size="small"
                                                class="search-item"
                                                v-model="partData.GoodName"
                                                :fetch-suggestions="searchGoodName"
                                                :debounce="500"
                                                placeholder="请输入配件名称"
                                                :trigger-on-focus="false"
                                            ></el-autocomplete>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <el-form-item label="英文名称" prop="ExAttribute4">
                                            <el-input v-model="partData.ExAttribute4" class="search-item" size="small"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <el-form-item label="库存数" prop="Inventory" suffix-icon="iconfont icon-sousuo">
                                            <el-input-number
                                                type="number"
                                                v-model="partData.Inventory"
                                                class="search-item"
                                                style="width: 170px"
                                                size="small"
                                                :min="minInventory"
                                            ></el-input-number>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-line">
                                    <div class="form-item">
                                        <el-form-item label="汽配编码" prop="APCode">
                                            <div style="width: 170px; display: flex; flex-direction: column; align-content: center; text-align: center">
                                                <el-input class="search-item" size="small" v-model="partData.APCode" @change="getAutoSeriesByApCode"></el-input>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <el-form-item label="汽配分类" prop="ExAttribute1">
                                            <el-autocomplete
                                                clearable
                                                popper-class="autocomplete"
                                                v-model.trim="partData.ExAttribute1"
                                                :fetch-suggestions="searchCate"
                                                value-key="Value"
                                                size="small"
                                            ></el-autocomplete>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <el-form-item label="预警上限" prop="ExAttribute2">
                                            <el-input-number
                                                style="width: 170px"
                                                type="number"
                                                v-model="partData.ExAttribute2"
                                                class="search-item"
                                                size="small"
                                                :min="0"
                                            ></el-input-number>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-line mb-10">
                                    <div class="form-item">
                                        <el-form-item label="产地">
                                            <el-autocomplete
                                                size="small"
                                                class="search-item"
                                                v-model="partData.Origin"
                                                :fetch-suggestions="searchOrigin"
                                                :debounce="500"
                                                placeholder="请输入产地"
                                                :trigger-on-focus="false"
                                            ></el-autocomplete>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <el-form-item label="汽配品牌" prop="Brand">
                                            <el-autocomplete
                                                clearable
                                                popper-class="autocomplete"
                                                v-model.trim="partData.Brand"
                                                :fetch-suggestions="searchBrand"
                                                value-key="Text"
                                                size="small"
                                            ></el-autocomplete>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <el-form-item label="预警下限" prop="ExAttribute3">
                                            <el-input-number
                                                style="width: 170px"
                                                type="number"
                                                v-model="partData.ExAttribute3"
                                                class="search-item"
                                                size="small"
                                                :min="0"
                                            ></el-input-number>
                                            <span class="invTip" @click="showLimitSet">点击快速设置各仓上下限</span>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-line">
                                    <div class="form-item" style="display: flex; flex-wrap: wrap; width: 100%">
                                        <div style="display: flex; align-items: center">
                                            <el-form-item label="成本价" prop="CostPrice">
                                                <div style="display: flex; align-items: center">
                                                    <el-input
                                                        type="number"
                                                        step="0.01"
                                                        v-model="partData.CostPrice"
                                                        class="search-item"
                                                        style="width: 150px"
                                                        size="medium"
                                                        @input="onCostPriceInput"
                                                        :min="0"
                                                    >
                                                        <template slot="append">¥</template></el-input
                                                    >
                                                    <div style="height: 40px; width: 40px; padding-left: 15px">✖&nbsp;</div>
                                                </div>
                                            </el-form-item>
                                        </div>
                                        <div>
                                            <div style="display: flex; flex-wrap: wrap; width: 100%">
                                                <el-form-item label-width="50px" label="点数" prop="PricePoint">
                                                    <div style="display: flex; align-items: center">
                                                        <el-input
                                                            type="number"
                                                            :step="0.1"
                                                            v-model="partData.PricePoint"
                                                            :min="0"
                                                            size="mini"
                                                            style="width: 60px"
                                                            @change="onPricePiontChange"
                                                            oninput="this.value=this.value.replace(!/^\d+(.\d{0,2})?$/, '');"
                                                        ></el-input>
                                                        <el-button v-show="isStopAutoCalc" size="small" class="calc-btn" @click="calcPrice"
                                                            ><i class="fa fa-calculator"></i
                                                        ></el-button>
                                                        <div style="height: 40px; width: auto; padding-left: 6px">&nbsp;=</div>
                                                    </div>
                                                </el-form-item>
                                                <el-form-item label-width="80px" label="批发价" prop="Price">
                                                    <div style="display: flex; align-items: center">
                                                        <el-input
                                                            type="number"
                                                            step="0.01"
                                                            v-model="partData.Price"
                                                            class="search-item"
                                                            style="width: 150px"
                                                            size="medium"
                                                            :min="0"
                                                            @change="onPriceChange"
                                                        >
                                                            <template slot="append">¥</template></el-input
                                                        >
                                                        <el-checkbox style="padding-left: 6px" v-model="isRoundNum1" :checked="isRoundNum1" @change="onIsCeilNumChange1"
                                                            >价格取整</el-checkbox
                                                        >
                                                    </div>
                                                </el-form-item>
                                            </div>
                                            <div style="display: flex; flex-wrap: wrap; width: 100%">
                                                <el-form-item label-width="50px" label="点数" prop="MarketPricePoint">
                                                    <div style="display: flex; align-items: center">
                                                        <el-input
                                                            type="number"
                                                            :step="0.1"
                                                            v-model="partData.MarketPricePoint"
                                                            :min="0"
                                                            size="mini"
                                                            style="width: 60px"
                                                            @change="onMarketPPChange"
                                                            oninput="this.value=this.value.replace(!/^\d+(.\d{0,2})?$/, '');"
                                                        ></el-input>
                                                        <el-button v-show="isStopAutoCalc" size="small" class="calc-btn" @click="calcMarketPrice"
                                                            ><i class="fa fa-calculator"></i
                                                        ></el-button>
                                                        <div style="height: 40px; width: auto; padding-left: 6px">&nbsp;=</div>
                                                    </div>
                                                </el-form-item>
                                                <el-form-item label-width="80px" label="零售价" prop="MarketPrice">
                                                    <div style="display: flex; align-items: center">
                                                        <el-input
                                                            type="number"
                                                            step="0.01"
                                                            v-model="partData.MarketPrice"
                                                            class="search-item"
                                                            size="medium"
                                                            style="width: 150px"
                                                            :min="0"
                                                            @change="onMarketPriceChange"
                                                        >
                                                            <template slot="append">¥</template></el-input
                                                        >
                                                        <el-checkbox style="padding-left: 6px" v-model="isRoundNum2" :checked="isRoundNum2" @change="onIsCeilNumChange2"
                                                            >价格取整</el-checkbox
                                                        >
                                                    </div>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-line">
                                    <div class="form-item">
                                        <el-form-item label="单位" prop="Unit">
                                            <el-autocomplete
                                                clearable
                                                popper-class="autocomplete"
                                                v-model.trim="partData.Unit"
                                                :fetch-suggestions="searchUnit"
                                                value-key="Value"
                                                size="small"
                                            ></el-autocomplete>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <el-form-item label="重量">
                                            <el-input type="number" step="0.01" v-model="partData.Quality" class="search-item" size="small" :min="0">
                                                <template slot="append">kg</template>
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <el-form-item label="配件尺寸" prop="Size">
                                            <el-input v-model="partData.Size" class="search-item" size="small"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-line">
                                    <div class="form-item">
                                        <el-form-item label="材质" prop="Texture">
                                            <el-input v-model="partData.Texture" class="search-item" size="small"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <el-form-item label="颜色" prop="Color">
                                            <el-input v-model="partData.Color" class="search-item" size="small"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item" v-if="isShowPerf">
                                        <el-form-item label="绩效属性" prop="PerfSetId">
                                            <el-select
                                                v-model="partData.PerfSetId"
                                                filterable
                                                clearable
                                                remote
                                                reserve-keyword
                                                size="small"
                                                @visible-change="perfVisibleChange"
                                            >
                                                <el-option
                                                    v-for="optionItem in perfSetList"
                                                    :key="optionItem.LevelId"
                                                    :label="optionItem.LevelName"
                                                    :value="optionItem.LevelId"
                                                >
                                                    <span style="float: left">{{ optionItem.LevelName }}</span>
                                                    <span style="float: right; color: #8492a6; font-size: 13px">（{{ optionItem.EarnPoint }}）</span>
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-line">
                                    <div class="form-item" style="width: 500px">
                                        <el-form-item label="包装尺寸" class="packageSize">
                                            长
                                            <input
                                                v-model.number="partData.Length"
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                size="small"
                                                oninput="this.value=this.value.replace(!/^\d+(.\d{0,2})?$/, '');"
                                                @blur="inputBlur"
                                                @focus="inputFocus"
                                            />
                                            &nbsp;宽
                                            <input
                                                v-model.number="partData.Width"
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                size="small"
                                                oninput="this.value=this.value.replace(!/^\d+(.\d{0,2})?$/, '');"
                                                @blur="inputBlur"
                                                @focus="inputFocus"
                                            />
                                            &nbsp;高
                                            <input
                                                v-model.number="partData.Height"
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                size="small"
                                                oninput="this.value=this.value.replace(!/^\d+(\.\d{0,2})?$/, '');"
                                                @blur="inputBlur"
                                                @focus="inputFocus"
                                            />
                                            (cm)
                                        </el-form-item>
                                    </div>
                                    <div class="form-item" style="width: 30%" v-if="isShowProject">
                                        <el-form-item label="合作项目" prop="ProjectId">
                                            <el-select
                                                class="cate-select search-item"
                                                v-model="partData.ProjectId"
                                                filterable
                                                clearable
                                                remote
                                                reserve-keyword
                                                size="small"
                                                @visible-change="projectVisibleChange"
                                            >
                                                <el-option
                                                    v-for="optionItem in projectList"
                                                    :key="optionItem.ProjectId"
                                                    :label="optionItem.ProjectName"
                                                    :value="optionItem.ProjectId"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-line">
                                    <div class="form-item">
                                        <el-form-item label="装箱规格" prop="PackingNum">
                                            <el-input
                                                v-model="partData.PackingNum"
                                                class="search-item"
                                                size="small"
                                                placeholder="整箱商品的数量：/箱，/个，/盒…"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-line">
                                    <div class="form-item" style="width: 30%">
                                        <el-form-item label="主要图片">
                                            <uploadFile
                                                ref="uploadMainFile"
                                                type="EntpTempGoods"
                                                :limit="1"
                                                :initfileList="partData.MainImg ? [partData.MainImg] : []"
                                                @uploadSuccess="uploadMainSuccess"
                                                @handleRemove="handleMainRemove"
                                                :wText="watermarkText"
                                            ></uploadFile>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item" style="width: 65%">
                                        <el-form-item label="辅助图片">
                                            <uploadFile
                                                ref="uploadMinorFile"
                                                type="EntpTempGoods"
                                                :multiple="true"
                                                :initfileList="uploadPictureList"
                                                @uploadSuccess="uploadMinorSuccess"
                                                @handleRemove="handleMinorRemove"
                                            ></uploadFile>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-line">
                                    <div class="form-item" v-if="isShowAutoSeriseEng">
                                        <el-form-item label="英文车型">
                                            <el-input v-model="partData.ExAttribute6" class="search-item" size="small"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                    <div class="form-main-mid">
                        <div class="title">
                            汽配互换码
                            <el-button size="small" class="search-btn btn-primary" @click="changeCodeMatchDialog">智能匹配</el-button>
                        </div>
                        <el-input
                            class="input-textarea"
                            type="textarea"
                            placeholder="输入请用回车隔行分开，如复制粘贴进来的格式必须带（半角 ',' 或全角逗号 '，'）才会自动转化成标准的回车格式"
                            v-model="enterGoodCode"
                            @paste.native.capture.prevent="handlePaste"
                            @change="getWatermarkText()"
                        ></el-input>
                    </div>
                    <div class="form-main-right" id="right">
                        <div class="car-type">
                            <div class="label"><span style="color: #f56c6c">*</span>适用车型</div>
                            <el-autocomplete
                                class="search-item"
                                size="medium"
                                :debounce="500"
                                v-model="partData.AutoSerise"
                                :fetch-suggestions="searchAutoSerise"
                                placeholder="请输入车型"
                                :trigger-on-focus="false"
                                @change="getWatermarkText()"
                            ></el-autocomplete>
                        </div>
                        <div class="row-table" style="margin-bottom: 24px">
                            <div class="row-head">
                                <span>选择的车型</span>
                                <el-button size="small" class="search-btn btn-primary" @click="selectCarType">选择车型</el-button>
                                <el-checkbox
                                    v-model="partData.AllModels"
                                    @change="allModelsChange"
                                    label="全车型"
                                    border=""
                                    size="small"
                                    style="background-color: #fff; margin-left: 10px"
                                ></el-checkbox>
                            </div>
                            <div class="row-body">
                                <!-- 弹框内选择车型后渲染的数据 -->
                                <div class="row-td" v-for="(item, index) in dialogCheckList" :key="index">
                                    <i class="el-icon-delete" @click="deleteCarTypeActive(1, index, item)"></i>
                                    {{ item.ModelDesc }}
                                </div>
                                <!-- 智能匹配选择车型后渲染的数据 -->
                                <div class="row-td" v-for="(item, index) in brainCheckList" :key="item.AutoSerieId">
                                    <i class="el-icon-delete" @click="deleteCarTypeActive(2, index, item)"></i>
                                    {{ item.ModelDesc }}
                                </div>
                                <div class="no-data" v-if="activeNoData">暂无数据</div>
                            </div>
                        </div>
                        <div class="row-table">
                            <div class="row-head">
                                <span>智能匹配到的车型</span>
                                <el-select v-model="checkedSelect" size="small" @change="changeSelectList">
                                    <el-option
                                        v-for="optionItem in checkSelectOptions"
                                        :label="optionItem.Brand"
                                        :key="optionItem.BrandId"
                                        :value="optionItem.BrandId"
                                    ></el-option>
                                </el-select>
                                <el-button size="small" class="search-btn btn-primary" @click="selectAllHandle">{{ selectAllText }}</el-button>
                            </div>
                            <div class="row-body">
                                <el-checkbox-group v-model="checkedCurrentList">
                                    <el-checkbox
                                        v-for="(item, index) in checkCurrentOptions"
                                        :key="index"
                                        class="checkbox-item"
                                        :label="item"
                                        @change="changeCheckBox($event, item, index)"
                                        >{{ item.ModelDesc }}</el-checkbox
                                    >
                                </el-checkbox-group>
                                <div class="no-data" v-if="carTypeNoData">暂无数据</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div style="text-align: left; width: 50%">
                        <el-button class="search-btn" type="primary" @click="showGoodImgRsDialog">共享图片</el-button>
                    </div>
                    <div style="text-align: right; width: 50%">
                        <el-button class="search-btn btn-primary" @click="handleClose" :disabled="loading">取消</el-button>
                        <el-button class="search-btn btn-primary" @click="submitConfirm" :disabled="loading">提交</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!--    快速存放商品    -->
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            title="快速存放商品"
            :visible.sync="storeVisible"
            width="1000px"
            append-to-body
            :before-close="closeStoreDialog"
        >
            <div v-if="storeVisible">
                <storeInventoryGoods :autopartItem="partData" @closeDialog="closeStoreDialog"></storeInventoryGoods>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="互换码智能匹配车型" :visible.sync="changeCodeMatchVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="changeCodeMatchVisible">
                <matchAutoSeries :changeCode="enterGoodCode" @closeDialog="confirmSeriesButton"></matchAutoSeries>
            </div>
        </el-dialog>
        <!--    车型选择    -->
        <el-dialog title="选择车系" :close-on-click-modal="false" :visible.sync="dialogVisible" :close-on-press-escape="false" append-to-body width="1380px">
            <selectSeries ref="selectSearise" :visible="dialogVisible" :selectOptions="dialogCheckList" :showSets="true" @confirmButton="confirmSeriesButton" />
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="各仓上下限设置" :visible.sync="limitSetVisible" append-to-body width="700px">
            <div class="dialog-content" v-if="limitSetVisible">
                <goodsLimitSet :GoodsId="goodsId" @closeDialog="limitSetClose"></goodsLimitSet>
            </div>
        </el-dialog>
        <!--    关联商品图片    -->
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            title="关联图片"
            :visible.sync="goodImgRsVisible"
            width="1000px"
            append-to-body
            :before-close="closeGoodImgRsDialog"
        >
            <div v-if="goodImgRsVisible">
                <goodsImgRs :PictureList="uploadPictureList" :GoodsId="partData.EntpTempGoodsId" @closeDialog="closeGoodImgRsDialog" @setImgRs="upImg"></goodsImgRs>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import uploadFile from '@/components/common/uploadBtn.vue';
import storeInventoryGoods from '@/components/business/goods/storeInventoryGoods.vue';
import matchAutoSeries from '@/components/business/goods/matchAutoSeries';
import selectSeries from '@/components/business/goods/selectSeries';
import goodsLimitSet from '@/components/business/goods/goodsLimitSet';
import goodsImgRs from '@/components/business/goods/goodsImgRs';
export default {
    name: '',
    props: {
        dialogFormVisible: {
            type: Boolean,
            default: false
        },
        goodsMsg: {
            type: Object
        },
        goodsId: String,
        apParams: {
            type: Object
        }
    },
    components: {
        uploadFile,
        storeInventoryGoods,
        matchAutoSeries,
        selectSeries,
        goodsLimitSet,
        goodsImgRs
    },
    data() {
        let checkPositive = this.$util.checkPositive;
        let checkAPCode = (rule, value, callback) => {
            if (!this.goodsId) {
                this.checkAPCode()
                    .then(() => {
                        return callback(new Error('已存在相同的商品'));
                    })
                    .catch(() => {
                        callback();
                    });
            } else {
                callback();
            }
        };
        let checkexAttribute3 = (rule, value, callback) => {
            this.checkexAttribute3()
                .then(result => {
                    if (!result) {
                        return callback(new Error('预警下限不得高于预警上限'));
                    } else {
                        callback();
                    }
                })
                .catch(() => {
                    callback();
                });
        };
        return {
            limitSetVisible: false,
            isCheckCode: true,
            isFromaAdd: false,
            tempGoodData: {},
            isAddNewAP: false,
            title: '添加为库存',
            dialogLoading: false,
            storeVisible: false,
            partData: {
                EntpTempGoodsId: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                MainImg: '',
                Price: 0,
                MarketPrice: 0,
                CostPrice: 0,
                APId: '',
                APCode: '',
                Size: '',
                Quality: '',
                Brand: '',
                Origin: '',
                Color: '',
                Texture: '',
                Unit: '',
                Inventory: 0,
                ExAttribute1: '',
                ExAttribute2: 100,
                ExAttribute3: 0,
                ExAttribute4: '',
                ExAttribute6: '',
                AutoSerise: '',
                PackageSize: '',
                PackingNum: '',
                PictureList: [],
                Length: 0,
                Width: 0,
                Height: 0,
                PricePoint: 1.0,
                MarketPricePoint: 1.0,
                PerfSetId: '',
                Source: '1', //表示商品是从弹窗新增或修改
                ProjectId: '',
                LimitSets: []
            },
            isRoundNum1: false,
            isRoundNum2: false,
            loading: false,
            brandList: [],
            apCategoryList: [],
            seriesList: [],
            unitList: [],
            uploadPictureList: [],
            projectList: [],
            inventoryCount: 0, //这个参数是用来判断是否有增加了库存，需要提醒去存放货物
            unInInventory: 0,
            minInventory: 0,
            rules: {
                APCode: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { validator: checkAPCode, trigger: 'blur' }
                ],
                APId: [{ required: true, message: '该项必填', trigger: 'change' }],
                GoodName: [{ required: true, message: '该项必填', trigger: 'blur' }],
                PictureList: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Price: [
                    { validator: checkPositive, trigger: 'blur' },
                    { required: true, message: '该项必填', trigger: 'blur' }
                ],
                MarketPrice: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { validator: checkPositive, trigger: 'blur' }
                ],
                CostPrice: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { validator: checkPositive, trigger: 'blur' }
                ],
                Quality: [{ required: false, validator: checkPositive, trigger: 'blur' }],
                Unit: [{ required: true, message: '该项必填', trigger: 'change' }],
                Inventory: [{ required: false, validator: checkPositive, trigger: 'blur' }],
                AutoSerise: [{ required: true, message: '该项必填', trigger: 'change' }],
                ExAttribute1: [{ required: true, message: '该项必填', trigger: 'change' }],
                Brand: [{ required: true, message: '该项必填', trigger: 'change' }],
                ExAttribute3: [{ validator: checkexAttribute3, trigger: 'blur' }],
                PerfSetId: [{ required: true, message: '该项必填', trigger: 'blur' }],
                ProjectId: [{ required: true, message: '该项必填', trigger: 'blur' }]
            },
            sptpsy: false, //商品图片添加水印
            watermarkText: '', //水印内容
            isShowPerf: false, //是否展示绩效属性
            perfSetList: [], //绩效属性列表
            isCalcPoint: false,
            enterGoodCode: '',
            dialogCheckList: [],
            // 智能车型已选项
            brainCheckList: [],
            // 智能车型-当前下拉框选中项 string BrandId
            checkedSelect: '',
            // 智能车型-下拉框列表 Array
            checkSelectOptions: [],
            // 智能车型-当前展示的列表 Array
            checkCurrentOptions: [],
            // 智能车型-将接口返回的数据缓存这里 Array
            checkAllOptions: [],
            // 智能车型-当前展示列表的已选项 Array
            checkedCurrentList: [],
            // 智能车型-所有列表的已选项-以BrandId为键名 Object
            checkedAllList: {},
            // 车型弹框显隐
            dialogVisible: false,
            // 被删除的车型
            // dialogClearOptions: [],
            //互换码智能匹配弹窗
            changeCodeMatchVisible: false,
            isShowProject: false,
            isShowAutoSeriseEng:false,
            //关联图片弹窗
            goodImgRsVisible: false,
            isStopAutoCalc: false //是否停止自动计算点数，停止后反向计算点数也失效
        };
    },
    watch: {
        isFromaAdd(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.addapcode.focus();
                });
            }
        }
    },
    computed: {
        activeNoData() {
            return (!this.dialogCheckList || this.dialogCheckList.length === 0) && (!this.brainCheckList || this.brainCheckList.length === 0);
        },
        carTypeNoData() {
            return !this.checkCurrentOptions || this.checkCurrentOptions.length === 0;
        },
        // 当前智能匹配到的车型的状态文字
        selectAllText() {
            let filArr = this.checkSelectOptions.filter(f => f.BrandId === this.checkedSelect);
            if (filArr.length > 0) {
                let status = filArr[0].isAllCheck;
                return status ? '取消全选' : '全选';
            } else {
                return '全选';
            }
        }
    },
    created() {
        if (this.goodsMsg) {
            this.title = '添加为库存';
            let apid = this.goodsMsg.Id;
            this.getConfigByCodes().then(() => {
                this.getAutoPartsByCodeOrId({ Code: '', Id: apid, ShowLoading: true });
            });
        } else if (this.goodsId && this.goodsId != '') {
            this.title = '编辑库存';
            this.getUnInInventory();
        } else {
            this.title = '新增库存';
            this.getConfigByCodes();
        }
        this.Source = '1';
    },
    mounted() {
        if (this.apParams && this.apParams.APCode) {
            this.partData.APCode = this.apParams.APCode;
            this.isFromaAdd = true;
        }
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['zdykcsx', 'sptpsy', 'cgrcdsglsj', 'cgrcdsgpfj', 'qyzdyspsx','zscxyw', 'xzqpbmdwyx', 'fxjsspds', 'splsjpfjmrqz', 'hzxmxzset', 'lspfbgjdsbh'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'zdykcsx':
                                    this.partData.ExAttribute2 = result ? Number(rValue) : 0;
                                    break;
                                case 'sptpsy':
                                    this.sptpsy = result;
                                    break;
                                case 'cgrcdsglsj': //零售
                                    this.partData.MarketPricePoint = result ? Number(rValue) : 1.0;
                                    break;
                                case 'cgrcdsgpfj': //批发
                                    this.partData.PricePoint = result ? Number(rValue) : 1.0;
                                    break;
                                case 'qyzdyspsx':
                                    this.isShowPerf = result;
                                    break;
                                case 'zscxyw':
                                    this.isShowAutoSeriseEng = result;
                                    break;
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;
                                case 'fxjsspds': //反向计算点数
                                    this.isCalcPoint = result;
                                    break;
                                case 'splsjpfjmrqz': //商品价格取整是否默认开启
                                    this.isRoundNum1 = result;
                                    this.isRoundNum2 = result;
                                    break;
                                case 'hzxmxzset':
                                    this.isShowProject = result;
                                    break;
                                case 'lspfbgjdsbh':
                                    this.isStopAutoCalc = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        getUnInInventory() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/GetEntpGoodsUnInInventory',
                    data: {
                        GoodsId: this.goodsId
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) this.unInInventory = res.data;

                    this.getEnterprisePart();
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        //成本价数值改变
        onCostPriceInput(val) {
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum1) {
                    //为什么要保留后面小数点2位，例如数据100*1.1这种情况会得到值110.00000000000001再取整会凭空多出变成111
                    let p = this.partData.CostPrice * this.partData.PricePoint;
                    this.partData.Price = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.Price = (this.partData.CostPrice * this.partData.PricePoint).toFixed(2);
                }
                if (this.isRoundNum2) {
                    let p = this.partData.CostPrice * this.partData.MarketPricePoint;
                    this.partData.MarketPrice = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.MarketPrice = (this.partData.CostPrice * this.partData.MarketPricePoint).toFixed(2);
                }
            }
        },
        //批发价加点改变
        onPricePiontChange() {
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum1) {
                    let p = this.partData.CostPrice * this.partData.PricePoint;
                    this.partData.Price = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.Price = (this.partData.CostPrice * this.partData.PricePoint).toFixed(2);
                }
            }
        },
        onPriceChange() {
            if (this.isCalcPoint && !this.isStopAutoCalc && this.partData.CostPrice && this.partData.CostPrice != 0)
                this.partData.PricePoint = (this.partData.Price / this.partData.CostPrice).toFixed(2);
        },
        onMarketPriceChange() {
            if (this.isCalcPoint && !this.isStopAutoCalc && this.partData.CostPrice && this.partData.CostPrice != 0)
                this.partData.MarketPricePoint = (this.partData.MarketPrice / this.partData.CostPrice).toFixed(2);
        },
        //市场价加点改变
        onMarketPPChange() {
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum2) {
                    let p = this.partData.CostPrice * this.partData.MarketPricePoint;
                    this.partData.MarketPrice = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.MarketPrice = (this.partData.CostPrice * this.partData.MarketPricePoint).toFixed(2);
                }
            }
        },
        //价格取整
        onIsCeilNumChange1(val) {
            this.isRoundNum1 = val;
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum1) {
                    let p = this.partData.CostPrice * this.partData.PricePoint;
                    this.partData.Price = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.Price = (this.partData.CostPrice * this.partData.PricePoint).toFixed(2);
                }
            } else {
                if (this.isRoundNum1) {
                    this.partData.Price = Math.ceil(this.partData.Price);
                } else {
                    this.partData.Price = this.partData.Price.toFixed(2);
                }
            }
        },
        onIsCeilNumChange2(val) {
            this.isRoundNum2 = val;
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum2) {
                    let p = this.partData.CostPrice * this.partData.MarketPricePoint;
                    this.partData.MarketPrice = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.MarketPrice = (this.partData.CostPrice * this.partData.MarketPricePoint).toFixed(2);
                }
            } else {
                if (this.isRoundNum2) {
                    this.partData.MarketPrice = Math.ceil(this.partData.MarketPrice);
                } else {
                    this.partData.MarketPrice = this.partData.MarketPrice.toFixed(2);
                }
            }
        },
        searchUnit(queryString, cb) {
            if (this.unitList && this.unitList.length > 0) {
                let list = this.unitList;
                this.querySearchAsync(list, queryString, cb);
            } else {
                this.searchGoodsUnit(cb);
            }
        },
        //匹配品牌
        searchBrand(queryString, cb) {
            if (this.brandList && this.brandList.length > 0) {
                let list = this.brandList;
                this.querySearchAsync(list, queryString, cb);
            } else {
                this.getEnterprisePartBrandList(cb);
            }
        },
        createStateFilter1(queryString) {
            return state => {
                return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        //匹配分类
        searchCate(queryString, cb) {
            if (this.apCategoryList && this.apCategoryList.length > 0) {
                let list = this.apCategoryList;
                this.querySearchAsync(list, queryString, cb);
            } else {
                this.getEntpApCategoryList(cb);
            }
        },
        querySearchAsync(list, queryString, cb) {
            let results = queryString ? list.filter(this.createStateFilter(queryString)) : list;
            cb(results);
        },
        createStateFilter(queryString) {
            return item => {
                if (item) {
                    let reg = new RegExp(queryString);
                    return reg.test(item.Text);
                }
            };
        },
        checkexAttribute3() {
            let that = this;
            return new Promise((resolve, reject) => {
                if (that.partData.ExAttribute3 != 0 && that.partData.ExAttribute2 != 0 && that.partData.ExAttribute3 >= that.partData.ExAttribute2) {
                    resolve(false);
                } else {
                    resolve(true);
                }
            });
        },
        // 校验编码是否重复
        checkAPCode() {
            let that = this;
            return new Promise((resolve, reject) => {
                if (that.isCheckCode) {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpGoods/ValidateEnterprisePartCode',
                            data: {
                                APCode: that.partData.APCode
                            },
                            hideLoading: true
                        })
                        .then(res => {
                            if (res.data) {
                                that.isAddNewAP = false;
                                resolve(); // 重复了
                            } else {
                                //新增库存时才匹配基础配件
                                if (that.partData.EntpTempGoodsId == '') {
                                    that.getAutoPartsByCodeOrId({
                                        Code: that.partData.APCode,
                                        Id: '',
                                        ShowLoading: false
                                    });
                                }
                                reject();
                            }
                        })
                        .catch(error => {
                            reject();
                        });
                } else {
                    that.isAddNewAP = true;
                    reject();
                }
            });
        },
        //获取基础汽配件数据
        getAutoPartsByCodeOrId(goodsMsg) {
            let that = this;

            if (goodsMsg.ShowLoading) {
                that.loading = true;
            }
            that.$util
                .axiosGet({
                    url: '/api/AutoParts/GetAutoPartsByCodeOrId',
                    data: {
                        apCode: goodsMsg.Code,
                        apId: goodsMsg.Id
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        this.tempGoodData = res.data;
                        if (goodsMsg.Id != '') {
                            //配件转库存
                            this.updataEntpPart();
                        } else {
                            this.isAddNewAP = true;
                        }
                    }
                    that.loading = false;
                })
                .catch(err => {
                    that.loading = false;
                });
        },
        updataEntpPart() {
            if (this.tempGoodData) {
                let autoParts = this.tempGoodData;
                if (autoParts.apImgs) {
                    this.uploadPictureList = autoParts.apImgs;
                }
                this.partData = {
                    GoodCode: autoParts.ChangeCode,
                    GoodName: autoParts.Cn,
                    MainImg: autoParts.PublicUrl,
                    APId: autoParts.Id,
                    APCode: autoParts.Code,
                    Quality: autoParts.Weight,
                    Unit: autoParts.Unit,
                    ExAttribute4: autoParts.En,
                    Inventory: 0,
                    Source: '1' //表示商品是从弹窗新增或修改
                };
                let packageSize = autoParts.PackageSize;
                if (packageSize) {
                    packageSize = packageSize.split('*');
                    if (packageSize) {
                        this.partData.Length = packageSize[0];
                        this.partData.Width = packageSize[1];
                        this.partData.Height = packageSize[2];
                    }
                }
                this.partData.Size = autoParts.Size;

                this.isAddNewAP = false;
            }
        },
        //获取品牌
        getEnterprisePartBrandList(cb) {
            this.$util.searchGoodsBrand().then(data => {
                this.brandList = data;
                cb(this.brandList);
            });
        },
        //获取单位
        searchGoodsUnit(cb) {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
                cb(this.unitList);
            });
        },
        //获取汽配分类
        getEntpApCategoryList(cb) {
            this.$util.searchGoodsType().then(data => {
                this.apCategoryList = data;
                cb(this.apCategoryList);
            });
        },
        //获取库存商品信息
        getEnterprisePart() {
            this.$util
                .getEnterprisePart(this.goodsId)
                .then(data => {
                    if (data) {
                        this.uploadPictureList = data.PictureList;
                        if (data.PackageSize) {
                            let packageSize = data.PackageSize;
                            if (packageSize.length >= 2) {
                                packageSize = packageSize[1].split('*');
                                if (packageSize) {
                                    data.Length = packageSize[0];
                                    data.Width = packageSize[1];
                                    data.Height = packageSize[2];
                                }
                            }
                        }
                        this.partData = {
                            EntpTempGoodsId: this.goodsId,
                            GoodCode: data.GoodCode,
                            GoodName: data.GoodName,
                            GoodDesc: data.GoodDesc,
                            MainImg: data.MainImg,
                            Price: data.Price,
                            MarketPrice: data.MarketPrice,
                            CostPrice: data.CostPrice,
                            APCode: data.APCode,
                            Size: data.Size,
                            Quality: data.Quality,
                            Brand: data.Brand,
                            Origin: data.Origin,
                            Color: data.Color,
                            Texture: data.Texture,
                            Unit: data.Unit,
                            Inventory: data.Inventory,
                            ExAttribute1: data.ExAttribute1,
                            ExAttribute2: data.ExAttribute2,
                            ExAttribute3: data.ExAttribute3,
                            ExAttribute4: data.ExAttribute4,
                            ExAttribute6: data.ExAttribute6,
                            AutoSerise: data.AutoSerise,
                            PackageSize: data.Size,
                            PackingNum: data.PackingNum,
                            PictureList: [],
                            Length: data.Length,
                            Width: data.Width,
                            Height: data.Height,
                            PricePoint: data.PricePoint,
                            MarketPricePoint: data.MarketPricePoint,
                            PerfSetId: '',
                            ProjectId: data.ProjectId
                        };
                        if (data.PerfSetId && (!this.perfSetList || this.perfSetList.length == 0)) {
                            this.$util.getPerfSets().then(list => {
                                if (list) this.perfSetList = list;
                                this.partData.PerfSetId = data.PerfSetId;
                            });
                        }

                        //这个参数是用来判断是否有增加了库存，需要提醒去存放货物
                        this.inventoryCount = data.Inventory;
                        this.minInventory = this.partData.Inventory - this.unInInventory;
                        this.getWatermarkText();
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //提交表单
        submitConfirm() {
            let that = this;
            if (!that.partData.AutoSerise) {
                that.$message.error('请输入适用车型');
                return;
            }
            that.$refs.partData.validate(valid => {
                if (valid) {
                    if (!that.partData.Length) {
                        that.partData.Length = 0;
                    }
                    if (!that.partData.Width) {
                        that.partData.Width = 0;
                    }
                    if (!that.partData.Height) {
                        that.partData.Height = 0;
                    }
                    if (!that.partData.ExAttribute2) {
                        that.partData.ExAttribute2 = 0;
                    }
                    if (!that.partData.ExAttribute3) {
                        that.partData.ExAttribute3 = 0;
                    }

                    that.partData.PackageSize = that.partData.Length + '*' + that.partData.Width + '*' + that.partData.Height;

                    if (that.uploadPictureList && that.uploadPictureList.length > 0) {
                        that.uploadPictureList = Array.from(new Set(that.uploadPictureList));
                        that.partData.PictureList = that.uploadPictureList;
                    }

                    // 提交时插入数据
                    that.partData.GoodsSeriesRs = [];
                    if (that.dialogCheckList.length > 0 || that.brainCheckList.length > 0) {
                        that.partData.GoodsSeriesRs = [...that.dialogCheckList, ...that.brainCheckList];
                    }
                    that.partData.GoodCode = '';
                    if (that.enterGoodCode) {
                        let code = that.enterGoodCode;
                        if (code.indexOf('\n') !== -1) {
                            code = code.split('\n').join(',');
                        }
                        that.partData.GoodCode = code;
                    }
                    that.submitData();
                }
            });
        },
        submitData() {
            let that = this;
            if (that.loading) return;
            that.loading = true;
            let url = '';
            let type = 0;
            let title = '';
            //传了goodsMsg是配件库的添加为库存,其余是新增或者编辑库存
            if (that.goodsMsg) url = '/api/EntpGoods/AddToInventory';
            else {
                url = '/api/EntpGoods/SaveEnterprisePart';
                if (that.goodsId) type = 1;
                else type = 2;
            }

            if (url) {
                that.$util
                    .axiosPost({
                        url: url,
                        data: that.partData,
                        hideLoading: true
                    })
                    .then(response => {
                        // that.loading = false;
                        switch (type) {
                            case 0:
                                title = '成功转为库存商品！';
                                break;
                            case 1:
                                title = '编辑商品成功！';
                                break;
                            case 2:
                                title = '添加为商品成功！';
                                break;
                        }
                        //返回的商品id
                        that.partData.EntpTempGoodsId = response.data;
                        //如果有库存变化，要提示去存放货物
                        let num = Number(that.partData.Inventory) - Number(that.inventoryCount) + Number(that.unInInventory);
                        if (num > 0) {
                            that.$confirm('监测到库存数量 ' + num + that.partData.Unit + '未存放，是否去存放货物？', title, {
                                confirmButtonText: '存放货物',
                                cancelButtonText: '取消',
                                type: 'success',
                                center: true
                            })
                                .then(() => {
                                    that.showStoreDialog();
                                })
                                .catch(() => {
                                    that.$emit('closeDialog', true, that.partData);
                                    that.resetForm();
                                });
                        } else {
                            that.$util.successMsg(title);
                            // 关闭弹窗
                            that.$emit('closeDialog', true, that.partData);
                            that.resetForm();
                        }
                    })
                    .catch(() => {
                        that.loading = false;
                    });
            }
        },
        showGoodImgRsDialog() {
            this.goodImgRsVisible = true;
        },
        closeGoodImgRsDialog() {
            this.goodImgRsVisible = false;
        },
        upImg(imgArr) {
            if (imgArr.length > 0) {
                if (this.partData.MainImg == '') {
                    this.partData.MainImg = imgArr[0];
                    imgArr.splice(0, 1);
                }
                let arr1 = [];
                imgArr.forEach(x => {
                    if (this.uploadPictureList.indexOf(x) == -1) {
                        arr1.push(x);
                    }
                });
                let arr2 = this.uploadPictureList.concat(arr1);
                this.uploadPictureList = arr2;
            }
        },
        // 上传主图片成功后执行
        uploadMainSuccess(res) {
            this.partData.MainImg = res;
        },
        // 删除主图片
        handleMainRemove(file) {
            this.partData.MainImg = '';
        },
        // 上传辅助图片成功后执行
        uploadMinorSuccess(res) {
            this.uploadPictureList.push(res);
        },
        // 删除辅助图片
        handleMinorRemove(file) {
            let fileUrl = file;
            let _pictureList = this.uploadPictureList;
            for (let i = 0; i < _pictureList.length; i++) {
                if (_pictureList[i] == fileUrl) {
                    _pictureList.splice(i, 1);
                }
            }
        },
        resetForm() {
            this.$refs.uploadMainFile.clearData();
            this.$refs.uploadMinorFile.clearData();
            this.partData = {};
            this.inventoryCount = 0;
        },
        handleClose() {
            //保存数据的时候禁止关闭弹窗
            if (this.loading) return;
            this.$emit('closeDialog');
            this.resetForm();
        },
        showStoreDialog() {
            this.storeVisible = true;
        },
        closeStoreDialog() {
            this.storeVisible = false;
            this.$emit('closeDialog', true, this.partData);
            this.resetForm();
        },
        inputBlur(event) {
            if (!event.target.value) event.target.value = 0;
        },
        inputFocus(event) {
            if (event.target.value == 0) event.target.value = '';
        },
        searchGoodName(key, cb) {
            this.$util.searchPartAttr(key, 1, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                if (cb) {
                    cb(arr);
                }
            });
        },
        searchOrigin(key, cb) {
            this.$util.searchPartAttr(key, 3, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                if (cb) {
                    cb(arr);
                }
            });
        },
        searchAutoSerise(key, cb) {
            this.$util.searchPartAttr(key, 2, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                if (cb) {
                    cb(arr);
                }
            });
        },
        getWatermarkText() {
            var watermarkText = '';
            let that = this;
            
            if (that.sptpsy) {
                if (that.partData.APCode != '') {
                    watermarkText = '编码：' + that.partData.APCode;
                }
                if (that.partData.GoodCode != '') {
                    let gcode = that.partData.GoodCode;
                    if (gcode.indexOf('\n') !== -1) {
                        gcode = gcode.split('\n')[0];
                    }
                    watermarkText += ';' + 'O  E：' + gcode;
                }

                if (that.partData.AutoSerise != '') {
                    let autos = that.partData.AutoSerise;
                    if (autos.Length > 50) autos = autos.substring(0, 50);
                    watermarkText += ';' + '车型：' + autos;
                }
            }
            this.watermarkText = watermarkText;
            setTimeout(() => {
                if (that.$refs.uploadMainFile) this.$refs.uploadMainFile.getWatermarkText(watermarkText);
                if (that.$refs.uploadMinorFile)this.$refs.uploadMinorFile.getWatermarkText(watermarkText);
            }, 500);
        },
        perfVisibleChange() {
            let that = this;
            if (that.perfSetList.length == 0) {
                that.$util.getPerfSets().then(data => {
                    if (data) that.perfSetList = data;
                });
            }
        },
        projectVisibleChange() {
            let that = this;
            if (that.projectList.length == 0) {
                that.$util.getCoProjects().then(data => {
                    if (data) that.projectList = data;
                });
            }
        },
        handlePaste(e) {
            let clip = e.clipboardData.getData('Text');
            if (clip) {
                let newVal = clip.replace(/\s*/g, '').replace(/,/g, '\n').replace(/，/g, ',');
                this.enterGoodCode = this.enterGoodCode + newVal.split(',').join('\n');
            }
        },
        // 选择车型
        selectCarType() {
            this.dialogVisible = true;
        },

        // 把选中数据，去重后插入选择的车型列表中
        //与匹配互换码共用
        confirmSeriesButton(row) {
            if (this.partData.AllModels) {
                this.partData.AllModels = false;
                this.dialogCheckList = [];
            }
            row.forEach(ele => {
                let item = ele;
                //EngineType==undefined的是车型选择的操作，反之是通过发动机选择的
                if (this.dialogVisible && item.EngineType == undefined) {
                    // item = ele[4];
                    item = {
                        AutoSerieId: ele[4].split('{$}')[0],
                        ModelDesc: ele[4].split('{$}')[1]
                    };
                }
                let index = this.dialogCheckList.findIndex(i => {
                    return i.AutoSerieId === item.AutoSerieId;
                });
                if (!~index) {
                    index = this.brainCheckList.findIndex(i => {
                        return i.AutoSerieId === item.AutoSerieId;
                    });
                    if (!~index) {
                        this.dialogCheckList.push(item);
                    }
                }
            });
            // this.dialogClearOptions = [];
            this.dialogVisible = false;
            this.changeCodeMatchVisible = false;
        },
        //全车型选择的变化
        allModelsChange(val) {
            if (val) {
                this.dialogCheckList = [{ BrandId: '全车型', AutoSerieId: '全车型', ModelDesc: '全车型' }];
                //去除智能匹配的选中
                this.brainCheckList = [];
                this.checkedCurrentList = [];
                this.checkSelectOptions.forEach(e => {
                    this.checkedAllList[e.BrandId] = [];
                    e.isAllCheck = false;
                });
            } else {
                this.dialogCheckList = [];
            }
        },
        changeCodeMatchDialog() {
            if (!this.enterGoodCode) {
                this.$message.warning('请输入互换码');
                return;
            }
            this.changeCodeMatchVisible = true;
        },
        // 切换智能车型品牌
        changeSelectList(aId) {
            let list = this.checkAllOptions;
            // 切换选框可选的列表
            this.checkCurrentOptions = list.filter(item => {
                return item.BrandId === aId;
            });
            // 切换当前选框选中集合
            this.checkedCurrentList = this.checkedAllList[aId];
            let findIndex = this.checkSelectOptions.findIndex(f => f.BrandId === this.checkedSelect);
            if (this.checkedCurrentList.length === this.checkCurrentOptions.length) {
                if (!this.checkSelectOptions[findIndex].isAllCheck) {
                    this.checkSelectOptions[findIndex].isAllCheck = true;
                }
            }
        },
        // 变更当前列表选中框
        changeCheckBox(result, row, rIndex) {
            this.checkedAllList[this.checkedSelect] = this.checkedCurrentList;
            let isAll = this.checkCurrentOptions.length === this.checkedCurrentList.length;
            // 将全选状态置为非全选
            let findIndex = this.checkSelectOptions.findIndex(f => f.BrandId === this.checkedSelect);
            if (!result && this.checkSelectOptions[findIndex].isAllCheck) {
                this.checkSelectOptions[findIndex].isAllCheck = false;
            }
            if (isAll) {
                this.checkSelectOptions[findIndex].isAllCheck = true;
            }
            this.noopsycheDataHandle();
        },
        /**
         * 智能匹配车型全选/取消全选
         */
        selectAllHandle() {
            // 没有列表不处理
            if (!this.checkedSelect) return;
            // 获取当前按钮对应列表下标
            let findIndex = this.checkSelectOptions.findIndex(f => f.BrandId === this.checkedSelect);
            let currentObj = this.checkSelectOptions[findIndex];
            // 筛选出当前列表未选中和选中的数据
            let resultObj = this.filterSingleList();
            if (resultObj.isAll) {
                // 取消全选列表
                this.checkedCurrentList = [];
                this.checkedAllList[this.checkedSelect] = [];
                this.checkSelectOptions[findIndex].isAllCheck = false;
                this.noopsycheDataHandle();
            } else {
                // 全选列表
                this.checkedCurrentList = [...resultObj.checkList, ...resultObj.notCheckList];
                this.checkedAllList[this.checkedSelect] = this.checkedCurrentList;
                this.checkSelectOptions[findIndex].isAllCheck = true;
                this.noopsycheDataHandle();
            }
        },
        // 筛选出当前智能车型列表的选中项、未选中项及判断是否全选
        filterSingleList() {
            // 根据两个列表长度判断当前列表是否已经全选
            let partList = this.checkCurrentOptions;
            let isAll = partList.length === this.checkedCurrentList.length;
            if (isAll) {
                return {
                    checkList: this.checkedCurrentList,
                    notCheckList: [],
                    isAll
                };
            } else {
                if (this.checkedCurrentList.length === 0) {
                    return {
                        checkList: [],
                        notCheckList: partList.map(m => m),
                        isAll
                    };
                }
                let checkList = [];
                let notCheckList = [];
                partList.forEach(item => {
                    let index = this.checkedCurrentList.findIndex(c => c.AutoSerieId === item.AutoSerieId);
                    if (~index) {
                        checkList.push(item);
                    } else {
                        notCheckList.push(item);
                    }
                });
                return {
                    checkList,
                    notCheckList,
                    isAll
                };
            }
        },
        // 处理智能车型展示列表
        noopsycheDataHandle() {
            if (this.partData.AllModels) {
                this.partData.AllModels = false;
                this.dialogCheckList = [];
            }
            let values = Object.values(this.checkedAllList);
            if (values) {
                var arr = values.reduce((p, r) => [...p, ...r], []);
                var newArr = [];
                arr.forEach(e => {
                    let index = this.dialogCheckList.findIndex(i => {
                        return i.AutoSerieId === e.AutoSerieId;
                    });
                    if (!~index) newArr.push(e);
                });
                this.brainCheckList = newArr;
            }
        },
        // 获取智能匹配车型
        async getAutoSeriesByApCode(type, row) {
            this.getWatermarkText();
            const {
                errcode,
                data: { Brands, Series }
            } = await this.$util.axiosPost({
                url: `/api/EntpGoods/GetAutoSeriesByApCode`,
                data: {
                    code: this.partData.APCode
                },
                hideLoading: true
            });
            if (errcode !== 0) {
                this.dialogCheckList = row;
                return;
            }
            if (Brands && Brands.length > 0) {
                // 处理下拉框展示数据
                this.checkSelectOptions = Brands.map(m => {
                    this.checkedAllList[m.BrandId] = [];
                    return {
                        isAllCheck: false,
                        ...m
                    };
                });
                // 当前下拉列表匹配关键字
                this.checkedSelect = this.checkSelectOptions[0].BrandId;
                // 处理智能匹配列表展示的数据
                this.checkCurrentOptions = Series.filter(item => {
                    return item.BrandId === this.checkedSelect;
                });
                this.checkAllOptions = Series;
            } else {
                this.checkedSelect = '';
                this.checkedAllList = {};
                this.checkSelectOptions = [];
                this.checkCurrentOptions = [];
                this.checkAllOptions = [];
            }
            // 处理编辑时展示的数据
            if (type === 'edit') {
                row.forEach(rEle => {
                    let sIndex = Series.findIndex(f => f.AutoSerieId === rEle.AutoSerieId);
                    if (~sIndex) {
                        rEle.BrandId === this.checkedSelect && this.checkedCurrentList.push(Series[sIndex]);
                        this.checkedAllList[rEle.BrandId].push(Series[sIndex]);
                    } else {
                        this.dialogCheckList.push(rEle);
                    }
                });
                if (this.checkSelectOptions.length > 0) this.checkSelectOptions[0].isAllCheck = this.checkedCurrentList.length === this.checkCurrentOptions.length;
                this.noopsycheDataHandle();
            }
        },
        // 删除添加的车型
        deleteCarTypeActive(type, index, row) {
            if (row.ModelDesc == '全车型') this.partData.AllModels = false;
            if (type === 1) {
                // this.dialogClearOptions.push(row);
                this.dialogCheckList.splice(index, 1);
            }
            if (type === 2) {
                if (this.checkedAllList && this.checkedAllList[row.BrandId]) {
                    let checkIndex = this.checkedAllList[row.BrandId].findIndex(i => i.AutoSerieId === row.AutoSerieId);
                    this.checkedAllList[row.BrandId].splice(checkIndex, 1);
                }

                this.noopsycheDataHandle();
                let ctIndex = this.checkSelectOptions.findIndex(f => f.BrandId === row.BrandId);
                if (ctIndex > -1) {
                    if (this.checkSelectOptions[ctIndex].isAllCheck) {
                        this.checkSelectOptions[ctIndex].isAllCheck = false;
                    }
                }

                let singleIndex = this.checkedCurrentList.findIndex(f => f.AutoSerieId === row.AutoSerieId);
                if (singleIndex > -1) this.checkedCurrentList.splice(singleIndex, 1);
            }
        },
        showLimitSet() {
            this.limitSetVisible = true;
        },
        limitSetClose(data) {
            this.limitSetVisible = false;
            if (data) {
                this.partData.LimitSets = data;
            }
        },
        calcMarketPrice() {
            if (this.isRoundNum2) {
                let p = this.partData.CostPrice * this.partData.MarketPricePoint;
                this.partData.MarketPrice = Math.ceil(p.toFixed(2));
            } else {
                this.partData.MarketPrice = (this.partData.CostPrice * this.partData.MarketPricePoint).toFixed(2);
            }
        },
        calcPrice() {
            if (this.isRoundNum1) {
                let p = this.partData.CostPrice * this.partData.PricePoint;
                this.partData.Price = Math.ceil(p.toFixed(2));
            } else {
                this.partData.Price = (this.partData.CostPrice * this.partData.PricePoint).toFixed(2);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.invTip {
    font-size: 12px;
    display: inline-block;
    position: absolute;
    top: 28px;
    left: 0;
    color: red;
}
.content-zone {
    display: flex;
    flex-direction: row;
    width: 100%;
}

.form-main-mid {
    width: 250px;
    padding: 0 12px;
    margin: 0 12px;
    border-left: 1px solid #dedede;
    border-right: 1px solid #dedede;
    display: flex;
    flex-direction: column;

    .title {
        padding: 16px 0;
    }

    .input-textarea {
        flex: 1;
    }
}

.form-main-right {
    width: 360px;

    .row-body {
        height: 200px;
        overflow-y: scroll;
        overflow-x: hidden;

        .no-data {
            height: 200px;
            line-height: 200px;
        }
    }

    .car-type {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 16px 0 12px 0;

        .label {
            flex-shrink: 0;
            margin-right: 16px;

            span {
                color: #f56c6c;
            }
        }
    }

    .row-head {
        padding: 12px 16px;
        background-color: #f5f7fa;
        border-top: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
        font-weight: 600;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        span {
            flex-shrink: 0;
            margin-right: 16px;
        }
    }

    .row-td {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        border-bottom: 1px solid #ebeef5;
    }

    .checkbox-item {
        width: 100%;
        padding: 12px 16px;
        border-bottom: 1px solid #ebeef5;
    }

    .el-icon-delete {
        font-size: 16px;
        color: #d9220a;
        margin-right: 16px;
        cursor: pointer;
    }
}

.form-main {
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;

    .el-form-item {
        margin-bottom: 10px;
    }
}

.form-line {
    display: flex;
    flex-direction: row;
}

.form-item {
    width: 250px;
}
.dialog-footer {
    display: flex;
    margin-top: 20px;
    padding-bottom: 10px;
}
.calc-btn {
    margin-left: 5px;
}
</style>
<style lang="less">
//辅助图片出现滚条
.el-upload-list {
    max-height: 120px;
    overflow-y: auto;
}

.packageSize {
    input {
        outline: none;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        border: none;
        border: 1px solid #dcdfe6;
        text-align: center;
        width: 100px;
    }

    input:disabled {
        color: #c0c4cc;
        cursor: not-allowed;
        background-color: #f5f7fa;
    }
}

.form-main-left {
    .el-input-group {
        vertical-align: middle;
    }
}

.form-main-mid {
    .el-textarea__inner {
        height: 540px;
    }
}
</style>
